var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('h1'),_c('h1',{staticClass:"display-inline"},[_vm._v("WIP Setup")]),_c('div',{staticClass:"display-inline ml-3"},[_c('ActiveApiCalls')],1),_c('p',[_vm._v("This is a summary of the WIP in WorkflowMax. This is not automatically updated, instead the WIP needs to be imported.")]),_c('WIPSetup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }